export default "__VITE_ASSET__1514e142__"